import { WarriorRarity } from '~/../api/common.types';
import {
  capitalizeFirstLetter,
  isBurned,
  isWarriorNamed,
  shortenedAddress,
} from '~/utils/utils';

function warriorStatus(warrior: WarriorRarity): string {
  const isDead = warrior.dead;
  if (isBurned(warrior.current_owner?.address)) {
    return 'burned';
  } else if (isDead) {
    return 'dead';
  }
  return 'alive';
}

// function tournamentStatus(
//   warrior: WarriorRarity,
//   tournamentParticipants: TournamentParticipants | null
// ): string {
//   if (!tournamentParticipants) {
//     return '';
//   }
//   if (tournamentParticipants.champions.includes(warrior.warrior.id)) {
//     return 'Champion';
//   }
//   if (tournamentParticipants.peaceful.includes(warrior.warrior.id)) {
//     return 'Peaceful';
//   }
//   if (tournamentParticipants.fallen.includes(warrior.warrior.id)) {
//     return 'Fallen';
//   }
//   return 'Not Active';
// }

function rowClasses(
  ownedWarriorIDs: Array<number>,
  warrior: WarriorRarity
): string {
  if (isBurned(warrior.current_owner?.address)) {
    return 'row-burned';
  } else if (ownedWarriorIDs.includes(warrior.warrior.id)) {
    return 'row-owned';
  }
  return '';
}

export default function LeaderboardTable(props) {
  const items = props.warriors as Array<WarriorRarity>;
  const deadOnlySelected = props.deadOnly;
  const ownedWarriorIDs = props.ownedWarriorIDs || [];
  // const tournamentParticipants = props.tournamentParticipants || null;
  return (
    <div className="table-wrapper">
      <table className="table">
        <thead>
          <tr>
            <th>
              <div>Rank</div>
            </th>
            <th>
              <div>Score</div>
            </th>
            <th>
              <div>Warrior</div>
            </th>
            <th>
              <div>HP</div>
            </th>
            <th>
              <div>Character</div>
            </th>
            <th>
              <div>State</div>
            </th>
            <th>
              <div>Level</div>
            </th>
            {/* <th>
              <div>Tournament</div>
            </th> */}
            <th>
              <div>Syndicate</div>
            </th>
            <th>
              <div>Owner</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {items &&
            !!items.length &&
            items
              .filter((item) => item?.level)
              .map((item, i) => (
                <tr key={i} className={rowClasses(ownedWarriorIDs, item)}>
                  <td>{item.rank + 1}</td>
                  <td>{Math.floor(item.rarity)}</td>
                  <td>
                    <a
                      href={`warrior/${item.warrior.id}`}
                      className="link"
                    >
                      {isWarriorNamed(item.warrior.name, item.warrior.id) ?
                        item.warrior.name :
                        item.warrior.id}
                      {ownedWarriorIDs?.includes(item.warrior.id)}
                    </a>
                  </td>
                  <td>{item.warrior.attributes.HP}</td>
                  <td>{item.warrior.attributes.Character}</td>
                  <td>{capitalizeFirstLetter(warriorStatus(item))}</td>
                  <td>{item.level}</td>
                  {/* <td>{tournamentStatus(item, tournamentParticipants)}</td> */}
                  <td>{item.warrior.attributes.Syndicate}</td>
                  <td>
                    {item.current_owner && (
                      item.current_owner.ens_name || shortenedAddress(item.current_owner?.address)
                    )}
                  </td>
                </tr>
              ))}
          {items && items.length == 0 && deadOnlySelected && (
            <tr>
              <td>What&apos;s</td>
              <td></td>
              <td>dead</td>
              <td></td>
              <td>may</td>
              <td></td>
              <td>never</td>
              <td></td>
              <td>die.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
